import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { Product } from "@/types/product";
import { useProductQueryCache } from "./use-product-query-cache";

export const useRecentProducts = () => {
  const { queryKeys, addToCache } = useProductQueryCache();

  return useQuery({
    queryKey: queryKeys.recent(),
    queryFn: async () => {
      const response = await apiRequest("GET", "/api/recent-products");
      if (!response.ok) {
        throw new Error("Failed to fetch recent products");
      }
      const data = (await response.json()) as Product[];

      // Add recent products to cache for cross-component access
      if (data.length > 0) {
        addToCache(queryKeys.initial(), data);
        console.log(
          "🟣 useRecentProducts: Cached",
          data.length,
          "recent products",
        );
      }

      return data;
    },
    staleTime: 2 * 60 * 1000, // Consider data fresh for 2 minutes
    gcTime: 15 * 60 * 1000, // Keep in cache for 15 minutes
  });
};
